import React from 'react';
import { colors } from '@material-ui/core';
import { Component } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import { closeModal, removeClinic } from '../../redux/actions';
import { setError } from '../../redux/actions/MessageAction';
import Alerts from '../common/Alerts';
class RemoveClinicModal extends Component {
  render() {
    return (
      <Modal
        ariaHideApp={false}
        isOpen={this.props.showModal}
        style={{
          content: { ...styles.centerModal },
        }}
        onRequestClose={this.props.closeModal}
        contentLabel={this.title}
      >
        <div style={styles.container}>
          <AiOutlineCloseCircle style={styles.closeButton} onClick={() => this.props.closeModal()} />
          <div>
            <div style={styles.title}>{this.props.title}</div>

            <div>Are you sure that you want to delete the clinic {this.props.selectedClinic?.name}? </div>
            <div
              onClick={() => {
                this.props.removeClinic(this.props.selectedClinic.id).then(() => {
                  this.props.closeModal();
                });
              }}
              style={styles.button}
            >
              Remove Clinic
            </div>
            <div
              onClick={() => {
                this.props.closeModal();
              }}
              style={{
                marginTop: '2rem',
                cursor: 'pointer',
                backgroundColor: 'red',
                border: 'none',
                color: 'white',
                padding: 7,
                textAlign: 'center',
                textDecoration: 'none',

                fontSize: 16,
                userSelect: 'none',
              }}
            >
              Cancel
            </div>
          </div>
          <Alerts />
        </div>
      </Modal>
    );
  }
}

const styles = {
  centerModal: {
    width: 600,
    height: 600,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // border: '1px solid'
  },
  insideContainer: {
    display: 'flex',
    flexDirection: 'column',
    // border: '1px solid'
  },
  title: {
    position: 'relative',
    top: -50,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 40,
  },
  buttonClose: {
    position: 'absolute',
    top: 1,
    right: 1,
  },
  button: {
    marginTop: '2rem',
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',

    fontSize: 16,
    userSelect: 'none',
  },
  error: {
    color: 'red',
  },
  buttonDisabled: {
    cursor: 'pointer',
    backgroundColor: '#9f9f9f',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScroll: {
    cursor: 'pointer',
    border: 'none',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScrollNoMore: {
    cursor: 'pointer',
    border: 'none',
    color: colors.purpleGrey,
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
};
const mapStateToProps = (state, ownProps) => {
  return {
    error: state.message.error,
    selectedClinic: state.clinic.selectedClinic,
    modal: state.modal,
  };
};

const mapDispatchToProps = {
  setError,
  removeClinic,
  closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveClinicModal);
